// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./sass/components/drawer.scss
// module id = 875
// module chunks = 0